<div class="d-flex d-md-flex justify-content-between align-items-center m-b-10">
  <fui-heading [text]="'Exchange Featured Creators'" [level]="5"></fui-heading>
  <button class="btn btn-secondary" (click)="addEditFeaturedCreator()">
    <fa-icon icon="plus"></fa-icon>
    Add
  </button>
</div>
<div class="row">
  <div class="col-md-12">
    @for (item of featuredCreators; track item) {
      <myp-list-item
        [photo]="item.image_url ? item.image_url : './assets/images/default_avatar.jpg'"
        [title]="item.name"
        [item]="item"
        [includeChevron]="false"
        [subData]="['Description: ' + item.blurb]"
      >
        <div class="button-content">
          <fa-icon icon="edit" class="action circle-icon-btn m-r-5" tabindex="0" (keyup.enter)="addEditFeaturedCreator(item)" (click)="addEditFeaturedCreator(item)"></fa-icon>
          <fa-icon icon="times" class="action circle-icon-btn" tabindex="0" (keyup.enter)="deleteFeaturedCreator(item, i)" (click)="deleteFeaturedCreator(item, i)"></fa-icon>
        </div>
      </myp-list-item>
    }
  </div>
</div>
